// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"286":"gas","417":"setting","560":"acid","908":"deviation"}[chunkId] || chunkId) + "." + {"286":"a7845954","417":"5a15ab87","560":"b0cda996","610":"61ff6bda","636":"da8a5c12","908":"8dbff0c8"}[chunkId] + ".css";
};